import { Collapse, Flex, ConfigProvider } from "antd";

const Widget = ({
  value,
  header,
  label,
  labelSecond,
  children,
  isOpen = true,
  extra,
}) => {
  const headerComponent = header || (
    <Flex align="center" gap={8} style={{ fontSize: 15, color: "#777777" }}>
      <span style={{ fontWeight: 500, color: "#303030" }}>{label}</span>
      <span>{labelSecond}</span>
    </Flex>
  );
  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            contentBg: "#E9E9E9",
            contentPadding: 8,
          },
        },
      }}
    >
      <Collapse
        className={`widget ${isOpen ? "open" : "closed"}`}
        items={[
          {
            key: value,
            showArrow: false,
            label: headerComponent,
            children: (
              <div className="widget-content">
                <div className="widget-body">{children}</div>
                <div className="widget-footer"></div>
              </div>
            ),
            extra: extra || null,
          },
        ]}
        activeKey={[isOpen ? value : ""]}
      />
    </ConfigProvider>
  );
};

export default Widget;
